import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#ED6A00" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/sushicr/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Mong Japanese Facebook"
              />
            </CFLink>
            {/* 
            <CFLink href="https://www.instagram.com/88noodles/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Mong Japanese Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#ED6A00" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/sushicr/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sushi Mong Japanese Facebook"
                hover
              />
            </CFLink>
            {/* 
            <CFLink href="https://www.instagram.com/88noodles/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sushi Mong Japanese Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
